import React, {useEffect, useRef, useState} from "react";
import {
  allColumns,
  itemsInputField as inputFieldsInit,
} from "./ApproveStatusList.config";
import {useAppDispatch, useAppSelector} from "../../../../../redux/hooks";
import {
  getApproveStatus,
  searchNghiBu,
} from "../../../../../redux/reducer/employee";
import {ColumnProps} from "../../../../../types/models";
import Notification from "../../../../../components/common/notification/notification";
import {ColumnPopoverDisplay, Search} from "../../../../../components/common";
import {Button, Col, Popover, Row, Space, Typography} from "antd";
import Icons from "../../../../../assets/icons";
import {ExcelSVG} from "../../../../../assets";

import axiosClient from "../../../../../api/_";
import {
  generateFileName,
  saveTableOptions,
  getTableOptions,
} from "../../../../../helper/common";
import CustomResizableTable from "components/common/CustomResizableTable/CustomResizableTable";
import {setButtonsHeader} from "redux/reducer/common";

const ApprovePermission = () => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear(); // Lấy năm hiện tại (ví dụ: 2023)
  const currentMonth = currentDate.getMonth() + 1; // Lấy tháng hiện tại (0 - 11, cần cộng thêm 1 để có giá trị tháng thực tế)
  const [data, setData] = useState<any[]>([]);
  const [params, setParams] = useState<any>({
    page: 1,
    limit: 10,
    nam: currentYear,
    thang: currentMonth,
  });
  const [loading, setLoading] = useState(false);
  let savedTableOption = getTableOptions(
    "APPROVESTATUS_TABLE",
    localStorage.getItem("username")
  );
  const defaultColumns = savedTableOption
    ? allColumns.map(cl => {
        if (savedTableOption.some(it => it.dataIndex === cl.dataIndex)) {
          let tmp = savedTableOption.find(it => it.dataIndex === cl.dataIndex);
          return {
            ...cl,
            show: true,
            width: tmp?.width ?? null,
          };
        } else
          return {
            ...cl,
            show: false,
          };
      })
    : allColumns;
  const [columns, setColumns] = useState<any>(
    defaultColumns.filter(e => e.show == true)
  );
  columns.map(e => {
    if (e.key == "index") {
      e.render = (text, record, index) => {
        const rowNumber = (currentPage - 1) * params.limit + index + 1;
        return rowNumber;
      };
    }
  });
  const [paramss, setParamss] = useState<any>({});

  const [currentPage, setCurrentPage] = useState(1);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  const dispatch = useAppDispatch();
  const expandRef = useRef<any>();
  const employees = useAppSelector(state => state.employeesReducer);
  useEffect(() => {
    getList({
      ...params,
    });
  }, [params]);
  useEffect(() => {
    dispatch(setButtonsHeader([]));
  }, []);
  const onClickSearch = async () => {
    setCurrentPage(1);
    var searchFields = expandRef?.current?.getData();
    searchFields = {
      ...searchFields,

      thang: searchFields.thang === null ? currentMonth : searchFields.thang,
    };
    setParams({...params, ...searchFields, page: 1}); // Đặt trang về 1 khi thực hiện tìm kiếm
  };
  // useEffect(() => {
  //   expandRef?.current.setFieldValue("nam", currentYear);
  //   expandRef?.current.setFieldValue("thang", currentMonth);
  // }, []);
  const getList = async params => {
    setLoading(true);
    setSelectedRowKeys([]);
    await dispatch(getApproveStatus(params));
    setLoading(false);
  };
  useEffect(() => {
    setData(
      employees.ApproveStatusList.map(list => ({
        ...list,
        key: list.id,
      }))
    );
  }, [employees.ApproveStatusList]);

  const setShowColumnsList = (showColumns, children) => {
    saveTableOptions(
      "APPROVESTATUS_TABLE",
      localStorage.getItem("username"),
      showColumns
    );
    setColumns(showColumns);
  };

  const setShowColumns = (showColumns: React.SetStateAction<ColumnProps[]>) => {
    setColumns(showColumns);
  };
  useEffect(() => {
    dispatch(
      getApproveStatus({
        page: 1,
        limit: 100,
      })
    );
  }, []);

  useEffect(() => {
    setOptionsPBFields(employees.phongBanList, "idPhongBan");
  }, [employees.phongBanList]);
  const setOptionsPBFields = (list, tenPhongBan) => {
    if (inputFieldsInit.find(field => field.name === tenPhongBan)) {
      inputFieldsInit.find(field => field.name === tenPhongBan).options =
        list?.map(item => ({
          value: item.id,
          label: item.tenPhongBan,
        }));
    }
  };

  const onChangePagination = (currentPage, pageSize) => {
    setCurrentPage(currentPage);
    setParams({...params, page: currentPage, limit: pageSize});
  };
  const onClickExport = async () => {
    var searchFields = expandRef?.current?.getData();
    setParamss({...paramss, ...searchFields});
    handleExportExcel(params);
  };

  const handleExportExcel = async params => {
    const url = "hanhchinhnhansu/nghi-bu/export-excel";
    const baseName = "nghi-bu";
    const fileExtension = "xlsx";
    const fileName = generateFileName(baseName, fileExtension);
    try {
      const response = await axiosClient.post(url, params, {
        responseType: "blob",
      });

      const blob = await response.data;

      // Create a blob URL
      const blobUrl = window.URL.createObjectURL(blob);

      // Create a link element for downloading
      const downloadLink = document.createElement("a");
      downloadLink.href = blobUrl;
      downloadLink.download = fileName;

      // Append the link to the document, trigger click, and remove the link
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    } catch (error) {
      // Handle the error, e.g., show an error message to the user

      Notification("error", "Error exporting Excel");
    }
  };
  const nam = params.nam;
  const thang = params.thang;
  const thangTruoc = thang - 1;
  const namTruoc = nam - 1;
  const filteredColumns = allColumns.filter(e => e.dataIndex === "nam");
  filteredColumns.forEach(column => {
    column.title = "Ngày nghỉ tồn chuyển sang tháng " + thang + "/" + nam;
  });
  allColumns.forEach(parentColumn => {
    if (parentColumn.children) {
      parentColumn.children.forEach(childColumn => {
        if (childColumn.dataIndex === "nghiPhepSuDungThangTruoc") {
          if (thang === 1) {
            childColumn.title =
              `Nghỉ phép sử dụng tháng ${12}` + `/${namTruoc}`;
          } else {
            childColumn.title =
              `Nghỉ phép sử dụng tháng ${thangTruoc}` + `/${nam}`;
          }
        }
        if (childColumn.dataIndex === "nghiBuSuDungThangTruoc") {
          if (thang === 1) {
            childColumn.title = `Nghỉ bù sử dụng tháng ${12}` + `/${namTruoc}`;
          } else {
            childColumn.title =
              `Nghỉ bù sử dụng tháng ${thangTruoc}` + `/${nam}`;
          }
        }
        if (childColumn.dataIndex === "soNgayLamThemPhatSinhThang") {
          if (thang === 1) {
            childColumn.title =
              `Số ngày làm thêm phát sinh tháng ${12}` + `/${namTruoc}`;
          } else {
            childColumn.title =
              `Số ngày làm thêm phát sinh tháng ${thangTruoc}` + `/${nam}`;
          }
        }
        if (childColumn.dataIndex === "soNgayLamThemDuocTinhLuongThang") {
          if (thang === 1) {
            childColumn.title =
              `Số ngày làm thêm được tính lương tháng ${12}` + `/${namTruoc}`;
          } else {
            childColumn.title =
              `Số ngày làm thêm được tính lương tháng ${thangTruoc}` +
              `/${nam}`;
          }
        }
        if (childColumn.dataIndex === "ngayNghiPhepThang") {
          childColumn.title =
            `Ngày nghỉ phép tháng ${thang}` +
            `/${nam} theo tiêu chuẩn được hưởng`;
        }
        if (childColumn.dataIndex === "soNgayNghiPhepNam") {
          childColumn.title = `Số ngày nghỉ phép năm ${namTruoc}`;
        }
        if (childColumn.dataIndex === "soNgayNghiBuNam") {
          childColumn.title = `Số ngày nghỉ bù năm ${namTruoc}`;
        }
      });
    }
  });

  const onKeyDown = e => {
    if (e.key === "Enter") {
      onClickSearch();
    }
  };

  return (
    <div
      className="standard-work-month-list"
      //   onKeyDown={onKeyDown}
      tabIndex={0}
    >
      <div className="standard-work-month-container">
        {/* <div className="container">
          <Search
            ref={expandRef}
            fields={inputFieldsInit}
            onClickSearch={onClickSearch}
            // Ẩn nút "Tìm kiếm nâng cao"
            showAdvancedSearch={false}
          />
        </div> */}
        <div className="container">
          <Space style={{width: "100%"}} direction="vertical">
            <Row justify={"space-between"} gutter={[16, 8]}>
              <Col>
                <Popover
                  trigger="click"
                  placement="topLeft"
                  content={
                    <ColumnPopoverDisplay
                      setShowColumns={setShowColumns}
                      columns={columns}
                      width={"400px"}
                    ></ColumnPopoverDisplay>
                  }
                >
                  <Button icon={<Icons.bars />} className="btn-sub">
                    Cột hiển thị
                  </Button>
                </Popover>
              </Col>
            </Row>
            {data && (
              <CustomResizableTable
                // rowSelection={{
                //     type: "radio",
                //     ...rowSelection,
                // }}
                setShowColumns={setShowColumnsList}
                pagination={{
                  position: ["bottomRight"],
                  showSizeChanger: true,
                  total: employees.NghiBuTotal,
                  onChange: onChangePagination,
                  current: currentPage,
                }}
                onRow={(record, rowIndex) => {
                  return {
                    // onDoubleClick: e => handleView(record.id),
                  };
                }}
                rowKey={record => record.id}
                columns={columns}
                dataSource={data}
                bordered={true}
                loading={loading}
                scroll={{x: 1500}}
              />
            )}
          </Space>
        </div>
      </div>
    </div>
  );
};

export default ApprovePermission;
